// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* KPI Dashboard Styles */

/* View Selector Buttons */
.kpi-view-selector {
  display: flex;
  gap: 10px;
}

.kpi-view-btn {
  padding: 10px 20px;
  border: 2px solid #e0e0e0;
  background-color: var(--color-white);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  color: var(--color-icon-muted);
}

.kpi-view-btn:hover {
  border-color: var(--color-primary-orange);
  color: var(--color-primary-orange);
  background-color: #fff5eb;
}

.kpi-view-btn.active {
  border-color: var(--color-primary-orange);
  background-color: var(--color-primary-orange);
  color: var(--color-white);
}

/* Time Period Filter */
.time-period-filter {
  display: flex;
  gap: 8px;
}

.period-btn {
  padding: 8px 16px;
  border: 1px solid #dee2e6;
  background-color: var(--color-white);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  color: #495057;
}

.period-btn:hover {
  background-color: var(--color-bg-hover);
  border-color: #adb5bd;
}

.period-btn.active {
  background-color: var(--color-primary-green);
  border-color: var(--color-primary-green);
  color: var(--color-white);
}

/* Metric Cards */
.metric-card {
  border: none;
  border-radius: 10px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.metric-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.metric-title {
  font-size: 13px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.metric-value {
  font-size: 28px;
  font-weight: 700;
  margin: 8px 0;
}

.metric-subtitle {
  font-size: 12px;
  margin-top: 4px;
}

.metric-icon {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}

.metric-trend {
  font-size: 13px;
  font-weight: 600;
}

.trend-positive {
  color: #28a745;
}

.trend-negative {
  color: #dc3545;
}

/* Priority Badge */
.priority-badge {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

/* Status Card */
.status-card {
  background-color: var(--color-bg-hover);
  border-radius: 8px;
  transition: transform 0.2s ease;
}

.status-card:hover {
  transform: scale(1.05);
  background-color: #e9ecef;
}

.status-count {
  font-size: 2rem;
  font-weight: bold;
}

.status-label {
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .kpi-view-selector {
    flex-direction: column;
  }

  .kpi-view-btn {
    width: 100%;
  }

  .time-period-filter {
    flex-wrap: wrap;
  }

  .period-btn {
    flex: 1 1;
    min-width: 80px;
  }

  .metric-value {
    font-size: 24px;
  }

  .metric-icon {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
}

/* Table Enhancements */
.table th {
  background-color: var(--color-bg-hover);
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  font-size: 14px;
  color: #495057;
}

.table tbody tr:hover {
  background-color: #f1f3f5;
}

/* Progress bars */
.progress {
  background-color: #e9ecef;
}

.progress-bar {
  transition: width 0.6s ease;
}
/* Trend Chart */
.trend-chart {
  height: 240px;            /* ← increase to accommodate rotated labels */
  padding: 10px 0;
}

.chart-bars {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  height: 160px;
  gap: 4px;
  border-bottom: 2px solid #dee2e6;
}

.chart-bar-wrapper {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;   /* ← pushes bar to bottom */
  height: 100%;
}

.chart-bar {
  width: 100%;
  border-radius: 4px 4px 0 0;
  position: relative;
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 4px;
  /* no min-height here */
}
.chart-labels {
  display: flex;
  justify-content: space-between;
  gap: 4px;
  margin-top: 4px;
  height: 40px;             /* ← give space for rotated labels */
  overflow: visible;
}
.bar-label {
  flex: 1 1;
  font-size: 9px;
  color: var(--color-icon-muted);
  text-align: center;
  white-space: nowrap;
  overflow: visible;        /* ← allow overflow */
  text-overflow: clip;
  transform: rotate(-45deg);
  transform-origin: top center;
  margin-top: 6px;
}
.icon-orange {
  color: var(--color-primary-orange);
}`, "",{"version":3,"sources":["webpack://./src/containers/ticketing/kpi_dashboard/KPIDashboard.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;EACzC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,uCAAuC;EACvC,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,uBAAuB;AACvB;EACE,uCAAuC;EACvC,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;AACA,gBAAgB;AAChB;EACE,aAAa,aAAa,6CAA6C;EACvE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,aAAa;EACb,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB,IAAI,2BAA2B;EACxD,YAAY;AACd;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,YAAY,cAAc,oCAAoC;EAC9D,iBAAiB;AACnB;AACA;EACE,SAAO;EACP,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB,SAAS,qBAAqB;EAC/C,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,kCAAkC;AACpC","sourcesContent":["/* KPI Dashboard Styles */\r\n\r\n/* View Selector Buttons */\r\n.kpi-view-selector {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.kpi-view-btn {\r\n  padding: 10px 20px;\r\n  border: 2px solid #e0e0e0;\r\n  background-color: var(--color-white);\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  font-weight: 500;\r\n  color: var(--color-icon-muted);\r\n}\r\n\r\n.kpi-view-btn:hover {\r\n  border-color: var(--color-primary-orange);\r\n  color: var(--color-primary-orange);\r\n  background-color: #fff5eb;\r\n}\r\n\r\n.kpi-view-btn.active {\r\n  border-color: var(--color-primary-orange);\r\n  background-color: var(--color-primary-orange);\r\n  color: var(--color-white);\r\n}\r\n\r\n/* Time Period Filter */\r\n.time-period-filter {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.period-btn {\r\n  padding: 8px 16px;\r\n  border: 1px solid #dee2e6;\r\n  background-color: var(--color-white);\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  font-size: 14px;\r\n  color: #495057;\r\n}\r\n\r\n.period-btn:hover {\r\n  background-color: var(--color-bg-hover);\r\n  border-color: #adb5bd;\r\n}\r\n\r\n.period-btn.active {\r\n  background-color: var(--color-primary-green);\r\n  border-color: var(--color-primary-green);\r\n  color: var(--color-white);\r\n}\r\n\r\n/* Metric Cards */\r\n.metric-card {\r\n  border: none;\r\n  border-radius: 10px;\r\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n\r\n.metric-card:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;\r\n}\r\n\r\n.metric-title {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.metric-value {\r\n  font-size: 28px;\r\n  font-weight: 700;\r\n  margin: 8px 0;\r\n}\r\n\r\n.metric-subtitle {\r\n  font-size: 12px;\r\n  margin-top: 4px;\r\n}\r\n\r\n.metric-icon {\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 24px;\r\n}\r\n\r\n.metric-trend {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n}\r\n\r\n.trend-positive {\r\n  color: #28a745;\r\n}\r\n\r\n.trend-negative {\r\n  color: #dc3545;\r\n}\r\n\r\n/* Priority Badge */\r\n.priority-badge {\r\n  display: inline-block;\r\n  width: 12px;\r\n  height: 12px;\r\n  border-radius: 50%;\r\n}\r\n\r\n/* Status Card */\r\n.status-card {\r\n  background-color: var(--color-bg-hover);\r\n  border-radius: 8px;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.status-card:hover {\r\n  transform: scale(1.05);\r\n  background-color: #e9ecef;\r\n}\r\n\r\n.status-count {\r\n  font-size: 2rem;\r\n  font-weight: bold;\r\n}\r\n\r\n.status-label {\r\n  font-size: 0.875rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 768px) {\r\n  .kpi-view-selector {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .kpi-view-btn {\r\n    width: 100%;\r\n  }\r\n\r\n  .time-period-filter {\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  .period-btn {\r\n    flex: 1;\r\n    min-width: 80px;\r\n  }\r\n\r\n  .metric-value {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .metric-icon {\r\n    width: 40px;\r\n    height: 40px;\r\n    font-size: 20px;\r\n  }\r\n}\r\n\r\n/* Table Enhancements */\r\n.table th {\r\n  background-color: var(--color-bg-hover);\r\n  border-bottom: 2px solid #dee2e6;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: #495057;\r\n}\r\n\r\n.table tbody tr:hover {\r\n  background-color: #f1f3f5;\r\n}\r\n\r\n/* Progress bars */\r\n.progress {\r\n  background-color: #e9ecef;\r\n}\r\n\r\n.progress-bar {\r\n  transition: width 0.6s ease;\r\n}\r\n/* Trend Chart */\r\n.trend-chart {\r\n  height: 240px;            /* ← increase to accommodate rotated labels */\r\n  padding: 10px 0;\r\n}\r\n\r\n.chart-bars {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: space-between;\r\n  height: 160px;\r\n  gap: 4px;\r\n  border-bottom: 2px solid #dee2e6;\r\n}\r\n\r\n.chart-bar-wrapper {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: flex-end;   /* ← pushes bar to bottom */\r\n  height: 100%;\r\n}\r\n\r\n.chart-bar {\r\n  width: 100%;\r\n  border-radius: 4px 4px 0 0;\r\n  position: relative;\r\n  transition: all 0.3s ease;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n  padding-top: 4px;\r\n  /* no min-height here */\r\n}\r\n.chart-labels {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 4px;\r\n  margin-top: 4px;\r\n  height: 40px;             /* ← give space for rotated labels */\r\n  overflow: visible;\r\n}\r\n.bar-label {\r\n  flex: 1;\r\n  font-size: 9px;\r\n  color: var(--color-icon-muted);\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  overflow: visible;        /* ← allow overflow */\r\n  text-overflow: clip;\r\n  transform: rotate(-45deg);\r\n  transform-origin: top center;\r\n  margin-top: 6px;\r\n}\r\n.icon-orange {\r\n  color: var(--color-primary-orange);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
